import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import React from "react";
import PackmanagerLink from "./PackmanagerLink";

export default function PackmanagerWorkOrderLink({ externalUuid, code }) {
  const applicationContext = useApplicationContext();
  const packmanagerWorkorderPath = externalUuid && `work_orders/${externalUuid}`;

  return (
    <PackmanagerLink applicationContext={applicationContext} packmanagerPath={packmanagerWorkorderPath}>
      {code}
    </PackmanagerLink>
  );
}
